<template>
<div class="home-page">
  <section class="wrapper light objective">
    <div class="lt-block block">
      <h2>site objective</h2>
      <p>High quality teaching products help students achieve excellent results in AP exams and lay the foundation for college and academic careers. Currently, we focus on AP physics courses, and in the future, we will gradually expand to math, biology and other natural science courses.</p>
      <ct-button @click="scrollPage('main-foundation')"
       type="text_primary"
       style="padding: 0;min-width: 0;"
       >Let's begin!<span class="underline"></span></ct-button>
    </div>
    <div class="rt-block block">
      <img src="@/assets/img/comet/home/tou.svg" alt="site objective">
    </div>
  </section>
  <section class="whatsnew" v-show="updatesLog">
    <div class="wrapper">
      <ct-row wrap="nowrap">
        <div class="title">
          <h2><strong>WHAT'S NEW</strong></h2>
          <div class="short-line"></div>
        </div>
        <div class="updates">
          <h3 style="line-height: 46px;">Update at {{updatesAt | fomateDate}}</h3>
          <div class="update-log">
            <div v-html="updatesLog"></div>
          </div>
        </div>
      </ct-row>
    </div>
  </section>
  <section class="wrapper dark main-foundation">
    <ct-row :gutter="15" v-for="(item, i) in functions" :key="i" :style="i === 1 ? 'margin: 32px -15px;flex-direction: row-reverse;' : ''">
      <ct-col :span="12">
        <div class="card">
          <h2><strong>{{item.title}}</strong></h2>
          <div class="shot-line"></div>
          <p class="desp">{{item.desp}}</p>
          <div class="action">
            <ct-button
             plain
             type="secondary"
             @click="goRoute(item.target)"
             >{{item.targetText}}<ct-icon
             name="jiantouyou"
             data-animate="float"
             ></ct-icon></ct-button>
          </div>
        </div>
      </ct-col>
      <ct-col :span="12" style="display: flex;align-items:center;">
        <div class="imgBox">
          <img :src="item.imgSrc" alt="">
        </div>
      </ct-col>
    </ct-row>
  </section>
  <section class="wrapper ap-program">
    <div class="ap-program-title">
      <h2><strong>ABSTRACT ON AP PROGRAM</strong></h2>
      <div class="short-line"></div>
    </div>
    <ct-row wrap="nowrap" align="center">
      <ct-col :padding="32" :span="24">
        <p class="desp">AP Program gives students the chance to tackle college-level work while they're still in high school and earn college credit and placement. It includes courses such as science, math and computer science, arts, social science etc. A score on AP exam gives students advantage when they apply college.</p>
      </ct-col>
      <ct-col :padding="32" :span="1" style="width:203px">
        <ct-button
         type="primary"
         @click="redirect('/approgram')"
        >Learn more<ct-icon
          name="jiantouyou"
          data-animate="float"
         ></ct-icon></ct-button>
      </ct-col>
    </ct-row>
  </section>
</div>
</template>
<script>
import api from '@ca/api'
import Times from '@/utils/time'
import { scrollPageByClass } from '@/utils'
import { vueAppStaticSite } from '@ca/constants/variables'
import courseImg from '@/assets/img/comet/home/1@2x.png'
import questionImg from '@/assets/img/comet/home/2@2x.png'
import liveImg from '@/assets/img/comet/home/3@2x.png'

export default {
  name: 'Home',
  data () {
    return {
      updatesAt: '',
      updatesLog: null,
      functions: [
        {
          title: 'LIGHT COURSE',
          desp: 'By extracting and explaining the core contents and theories from a specific concept to help students establish comprehensive understandings, It is dependable and beneficial for rookie learners to study AP@Physics courses.',
          target: '/courses',
          targetText: 'Get started',
          imgSrc: courseImg
        }, {
          title: 'QUESTION BANK',
          desp: 'Numerous questions organized in chapters of skills help learners apply what they learn to specific problems and provide top-quality mock for students who have been preparing AP Physics exams.',
          target: '/quiz',
          targetText: 'Try now',
          imgSrc: questionImg
        }, {
          title: 'Live Course',
          desp: 'Numerous questions organized in chapters of skills help learners apply what they learn to specific problems and provide top-quality mock for students who have been preparing AP Physics exams.',
          target: '/live',
          targetText: 'Get started',
          imgSrc: liveImg
        }
      ]
    }
  },
  filters: {
    fomateDate (timestamp) {
      if (timestamp) {
        return Times.utcToLocal(timestamp * 1000, 'MMM Do')
      } else {
        return timestamp
      }
    }
  },
  methods: {
    goRoute (routePath) {
      this.$router.push(routePath)
    },
    redirect (path) {
      window.location = `${vueAppStaticSite}${path}`
    },
    scrollPage (className) {
      scrollPageByClass(className, {
        block: 'start'
      })
    }
  },
  mounted () {
    api.getUpdateLog().then(res => {
      if (res && res.data && res.data.code === 1) {
        const { content, updated_at: updatesAt } = res.data.data
        this.updatesLog = content
        this.updatesAt = updatesAt
      }
    })
  }
}
</script>
<style scoped lang="scss">
@import '@/styles/_varaible.scss';
$rightW: 364px;

@keyframes fadeIn{
  0%{
    opacity: 0
  }
  100%{
    opacity: 1
  }
}
@keyframes fadeOut{
  0% {
    opacity: 1
  }
  100%{
    opacity: 0
  }
}
.home-page {
  width: 100%;
  h3{
    font-family:SFProDisplay-Medium;
    font-weight:500;
  }
  .objective {
    margin-top: 16px;
    margin-bottom: 40px;
    h2 {
      margin-bottom: 8px;
    }
    p {
      margin-bottom: 32px;
    }
    .lt-block {
      color: #fff;
      background-color: $secondary;
      padding: 32px;
      margin-right: $rightW;
      h2 {
        color: #fff;
      }
    }
    .rt-block{
      background-color: $primary;
      width:$rightW;
      position:absolute;
      top: 0;
      right: 0;
      height: 100%;
      overflow-y: hidden;
      text-align: center;
      img {
        margin-top: -20px;
        width: 256px;
      }
    }
  }
  .whatsnew {
    background: #F7FBFF;
    .wrapper {
      padding: 40px 0;
    }
    .updates{
      margin-left: 260px;
    }
  }
  .whatsnew .title {
    word-break: break-all;
    padding: 0 40px 0 0;
    position: absolute;
  }
  .short-line {
    width:48px;
    height:2px;
    background:$primary;
    margin-top: 16px;
  }
  p.desp {
    font-size:16px;
    font-weight:400;
    color:#365572;
  }
  $cubic: cubic-bezier(0.48,0,0.32,1);
  .card {
    padding: 0;
    height: 100%;
    background:rgba(255,255,255,1);
    text-align: left;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    max-width: 539px;
    .ct-button:hover{
      background:$secondary;
      border:1px solid $secondary;
      color: #fff;
      transition: all .1s ease-out;
    }
    h2{
      margin-bottom: 16px;
    }
    .shot-line {
      width: 48px;
      height: 2px;
      background: $primary;
      margin-bottom: 20px;
    }
    p {
      position: relative;
      margin-bottom: 32px;
      line-height:22px;
      z-index: 2;
    }
    @media screen and (max-width: 992px){
      padding: 0;
      p {
        margin-bottom: 10px;
      }
    }
    &-icon{
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 1;
      img {
        vertical-align: bottom;
      }
    }
  }
  .ap-program {
    padding: 48px 0;
    margin-bottom: 56px;
    box-shadow:0px 4px 24px 0px rgba(35,62,114,0.1);
    &-title{
      margin: 0 32px 10px;
    }
  }
}
.light {
  position: relative;
}
.dark {
  padding: 56px 0;
  .ct-row {
    .imgBox {
      text-align: right;
      img {
        width: 100%;
        max-width: 539px;
        vertical-align: middle;
      }
    }
    &:nth-child(2) {
      .imgBox {
        text-align: left;
        img {
          max-width: 490px;
        }
      }
      .card {
        margin-left: auto;
      }
    }
  }
}
.update-log{
  font-size:14px;
  font-family:SFProText;
  font-weight:400;
  color:rgba(54,85,114,1);
  word-wrap:break-word;
  word-break: break-word;
}
</style>
